import React, { useState, useRef, useEffect } from "react";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { useParams } from "react-router-dom";
import { getAllDetails } from "../../service/ApiService";
import { GET_DETAIL_SUMMARY_TAXPAYER } from "../../config/ApiConstant";
import { formatDate } from "../../appconfig/AppHelper";
import moment from "moment";
import Loader from "../../components/Loader/Loader";

const SlotBooking = () => {
  document.title = "Nagra Accounting";
  const { taxpayerId } = useParams();

  // tax payer id
  const id = taxpayerId ? atob(taxpayerId) : null;

  const toast = useRef<any>(null);

  // loading
  const [pageLoading, setPageLoading] = useState<boolean>(false);

  // booking summary based on state
  const [bookingSummary, setBookingSummary] = useState<any>(null);

  // available slots
  const [bookingAvailableSlot, setBookingAvailableSlot] = useState<any>(null);

  //   useeffect to get slots
  useEffect(() => {
    // getAvailableSlots();
    getTaxPayerSummary();
  }, []);

  // get detail summary of tax payer
  const getTaxPayerSummary = async () => {
    try {
      setPageLoading(true);
      const response = await getAllDetails(`${GET_DETAIL_SUMMARY_TAXPAYER}/${id}`);

      if (response) {
        setBookingSummary(response);
        setBookingAvailableSlot(JSON.parse(response?.slot?.date));
        setPageLoading(false);

        // Reset form after successful submission
        localStorage.removeItem("userFormData");
        localStorage.removeItem("taxPayerId");
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
      setPageLoading(false);
    }
  };

  // tax filing date completed within
  const taxFilingCompletedWithin = () => {
    if (!window.cn(bookingAvailableSlot)) {
      const firstDate = bookingAvailableSlot[0];

      const lastDate = bookingAvailableSlot[bookingAvailableSlot?.length - 1];

      return ` ${formatDate(firstDate)} to ${formatDate(lastDate)}`;
    }
  };

  return (
    <div className="slot-booking-page relative">
      <Toast ref={toast} />

      <div className="relative">
        {/* Success Message Banner */}
        <div className="success-banner">
          <div className="success-content">
            <i className="pi pi-check-circle"></i>
            {!window.cn(bookingSummary) !== null && (
              <div className="success-text">
                <h3>Tax File Submitted!</h3>
                <p>
                  Your tax filing process will be completed with given dates:
                  {taxFilingCompletedWithin()}
                </p>
              </div>
            )}
          </div>
        </div>
        {pageLoading == true ? (
          <Loader />
        ) : (
          <div className="booking-container">
            <Card className="booking-card">
              <div className="booking-header">
                {" "}
                <h1>Tax Filing Detail </h1>
              </div>

              {!window.cn(bookingSummary) !== null && (
                <div>
                  <div className="tax-payer-summary">
                    <div className="summary-header">
                      <h2>Tax Filer Information</h2>
                    </div>

                    <div className="summary-content">
                      <div className="details-grid">
                        <div className="detail-item">
                          <label>Full Name</label>
                          <span className="value">
                            {bookingSummary?.first_name || bookingSummary?.last_name
                              ? `${bookingSummary?.first_name ?? ""} ${bookingSummary?.middle_name ?? ""} ${bookingSummary?.last_name ?? ""}`.trim()
                              : "-"}
                          </span>
                        </div>

                        <div className="detail-item">
                          <label>Email Address</label>
                          <span className="value">{bookingSummary?.email}</span>
                        </div>

                        <div className="detail-item">
                          <label>Phone Number</label>
                          <span className="value">{bookingSummary?.phone}</span>
                        </div>

                        <div className="detail-item">
                          <label>City</label>
                          <span className="value">{bookingSummary?.city}</span>
                        </div>

                        <div className="detail-item">
                          <label>Tax filing will be completed within given dates</label>
                          <span className="value">
                            <b className="bold" style={{ fontWeight: "600" }}>
                              {taxFilingCompletedWithin()}
                            </b>
                          </span>
                        </div>

                        <div className="detail-item">
                          <label>Street Address</label>
                          <span className="value">{bookingSummary?.street_address}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </div>
        )}
      </div>
    </div>
  );
};

export default SlotBooking;
